import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '~environment';

@Component({
  selector: 'app-header-n',
  templateUrl: './header-n.component.html',
  styleUrls: ['./header-n.component.scss']
})
export class HeaderNComponent implements OnInit {

  readonly tk: string = `${environment.dbUsed}`;;

  @Output() modalSelect = new EventEmitter();

  constructor(public router: Router) {
    router.events.subscribe((val) => {
      jQuery(document).ready(function () {
        $("#checkMenu").prop("checked", false);
      });
    });
  }

  ngOnInit(): void {
  }

  clickM() {
    const url = environment.dbUsed === 'pruebas' ? 'https://accounts.qa.triidy.com/register' : 'https://accounts.triidy.com/register';
    window.open(url, '_self')
    // this.modalSelect.emit(true);
  }

  descargaWin(): void {
    window.open('https://triidyftp.s3.us-east-2.amazonaws.com/Triidy.rar', '_blank');
  }

  descargaAnd(): void {
    window.open('https://play.google.com/store/apps/details?id=app.avalon.triidy', '_blank');
  }




}
